import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Translate } from "react-thunk-i18nify";

import { subscriptionUsageReportFetchRequest } from "redux/actions/cellPhoneReport/subscriptionUsage";

import YearMonthFilter from "components/CellPhoneSubscriptionUsage/YearMonthFilter";
import AllUsagesReport from "components/CellPhoneSubscriptionUsage/AllUsagesReport";

const CellPhoneSubscriptionUsage = ({
  match: {
    params: { cellPhoneNumber },
  },
  fetchSubscriptionUsageReport,
  subscriptionUsage,
  isLoading: isSubscriptionUsageFetching,
}) => {
  const fetchSubscriptionUsageReportData = (filterYearMonth) => {
    fetchSubscriptionUsageReport(cellPhoneNumber, filterYearMonth);
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    const filterYearMonth = `${currentYear}-${currentMonth}`;

    fetchSubscriptionUsageReportData(filterYearMonth);
  }, [cellPhoneNumber]);

  return (
    <div className="cell-phone-detail container-fluid w-100">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 me-3">
          <Translate value="common.subscriptionUsage" /> ({cellPhoneNumber})
        </h3>

        <YearMonthFilter
          cellPhoneNumber={cellPhoneNumber}
          fetchSubscriptionUsageReportData={fetchSubscriptionUsageReportData}
          isSubscriptionUsageFetching={isSubscriptionUsageFetching}
        />
      </div>

      <AllUsagesReport subscriptionUsage={subscriptionUsage} />
    </div>
  );
};

CellPhoneSubscriptionUsage.defaultProps = {
  isLoading: "true",
};

CellPhoneSubscriptionUsage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      cellPhoneNumber: PropTypes.string,
    }),
  }).isRequired,
  fetchSubscriptionUsageReport: PropTypes.func.isRequired,
  subscriptionUsage: PropTypes.shape(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool,
};

const mapStateToProps = ({ cellPhoneReport }) => ({
  ...cellPhoneReport.subscriptionUsage,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSubscriptionUsageReport: (cellNumber, forYearMonth) => {
    dispatch(subscriptionUsageReportFetchRequest(cellNumber, forYearMonth));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CellPhoneSubscriptionUsage);
